import { UserGroupRules } from 'src/graphql/entities/group-rules/group-rules.types';

export const hasWorkflowManagementAccess = (
  userGroupRules: Partial<Record<UserGroupRules, boolean | number[]>>,
): boolean => userGroupRules[UserGroupRules.AccessToManageProvisionWorkflows] === true;
